"use client";

import Context from "@/context/Context";
import AnnouncementBar from "@/components/Header/AnnouncementBar";
import HeaderDashboard from "@/components/Header/HeaderDashboard";
import PopupMobileMenu from "@/components/Header/PopUpMobileMenu";
import Plans from "@/components/Plan/Plans";
import Footer from "@/components/Footers/Footer";
import HomeChatSwitcher from "@/components/Common/HomeChatSwitcher";

const PlansClient = () => (
  <main className="page-wrapper rbt-dashboard-page">
    <Context>
      <div className="rbt-panel-wrapper">
        <AnnouncementBar />
        <HeaderDashboard display="d-none" />
        <PopupMobileMenu />
        <Plans />
        <Footer />
        <HomeChatSwitcher />
      </div>
    </Context>
  </main>
);

export default PlansClient;
